export var URL_ROUTE = {
    CASES: 'cases',
    USERS: 'users',
    CASE_DETAIL: "cases/:productInfo",
    API_CHECK: "check",
    AUTO_SEARCH: 'auto-search',
};
export var URL_PATH = {
    CASES: '/cases',
    USERS: '/users',
    CASE_DETAIL: function (product, token) { return "/cases/".concat(product, ":").concat(token); },
    CASE_DETAIL_WITHOUT_PRODUCT: function (token) { return "/cases/".concat(token); },
    API_CHECK: '/check',
    AUTO_SEARCH: '/auto-search',
};
export var windowExist = typeof window !== 'undefined';
export var workEnv = windowExist ? (window.env ? window.env.ENV : 'dev') : 'dev';
export var isLocalRun = workEnv === 'local';
export var REGEX = {
    IS_I18N_KEYMAP_NO_PARAMS: /^t\('.*'\)$/g,
    IS_I18N_KEYMAP_WITH_PARAMS: /^t\('.*',\s*{.*}\)$/g,
    OBJECT: /{.*}/g,
    STRING: /".+"/g,
    KEY_PATH: /'[a-zA-Z.$]+'/g,
    VARIABLE_IN_KEY_PATH: /\$[a-zA-Z]+/g,
    TEMPLATE_KEY: /\$\w{1,}/g,
    TEMPLATE_JSON_PATH: /\[\?\(@\.[a-zA-Z]*=='\$[a-zA-Z]*'\)]/,
};
export var ZERO_WIDTH_SPACE = '\u200B';
export var LOCAL_STORAGE_KEY = 'Middle-office';
export var BROADCAST_CHANNEL = 'middle-office-broadcast-channel';
export var NUMBER_25 = 25;
export var NUMBER_50 = 50;
export var NUMBER_100 = 100;
export var NUMBER_250 = 250;
export var SOUNDS = {
    NOTIFICATION: '/audio/notification.mp3',
    ERROR_NOTIFICATION: '/audio/errorNotification.mp3',
};
export var IMAGES_TO_CACHE = {
    FAVICON: '/images/favicon.png',
    FAVICON_BLUE: '/images/favicon-blue.png',
    FAVICON_GREEN: '/images/favicon-green.png',
    FAVICON_ORANGE: '/images/favicon-orange.png',
    FAVICON_RED: '/images/favicon-red.png',
};
export var MAX_APPLICANTS_TO_DISPLAY = 3;
